 import React, { useEffect, useRef, useState } from 'react';
import CameraAlt from '@mui/icons-material/CameraAlt';
import DeleteIcon from '@mui/icons-material/Delete';
import { Avatar, Box, IconButton } from '@mui/material';

interface SettingsOrglogoProps {
  inputRef: React.RefObject<HTMLInputElement>;
  selectedFile: File | null;
  setSelectedFile: React.Dispatch<React.SetStateAction<File | null>>;
  handleAvatarClick: () => void;
  handleFileChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  hasPermission: boolean;
  logo: string;
  handleDeleteLogo?: () => void;
}

const SettingsOrglogo: React.FC<SettingsOrglogoProps> = ({
  inputRef,
  selectedFile,
  logo,
  handleAvatarClick,
  handleFileChange,
  hasPermission,
  handleDeleteLogo,
}) => {
  const [imagePreview, setImagePreview] = useState<string>(logo);
  const [isHovered, setIsHovered] = useState(false);
  
  useEffect(() => {
    if (selectedFile) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result as string);
      };
      reader.readAsDataURL(selectedFile);
    } else {
      setImagePreview(logo);
    }
  }, [selectedFile, logo]);
  
  const hasLogo = imagePreview && imagePreview !== '';
  
  return (
    <Box
      sx={{
        width: 50,
        height: 50,
        position: 'relative',
        overflow: 'visible',
        cursor: 'pointer',
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <Avatar alt="Organization Logo" src={imagePreview} sx={{ width: 50, height: 50 }}></Avatar>
      {isHovered && (
        <>
          <div
            className="overlay"
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              background: 'rgba(0, 0, 0, 0.5)',
              borderRadius: '50%',
              zIndex: 1,
            }}
          />
          <IconButton
            disabled={!hasPermission}
            onClick={handleAvatarClick}
            color="primary"
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              width: 50,
              height: 50,
              zIndex: 2,
            }}
          >
            <CameraAlt sx={{ color: '#fff' }} />
          </IconButton>
          {hasLogo && hasPermission && handleDeleteLogo && (
            <IconButton
              onClick={(e) => {
                e.stopPropagation();
                handleDeleteLogo();
              }}
              sx={{
                position: 'absolute',
                bottom: -8,
                right: -8,
                backgroundColor: '#FF0000',
                color: '#fff',
                width: 24,
                height: 24,
                zIndex: 3,
                '&:hover': {
                  backgroundColor: '#CC0000',
                },
              }}
            >
              <DeleteIcon sx={{ fontSize: 14 }} />
            </IconButton>
          )}
        </>
      )}

      <input ref={inputRef} type="file" accept="image/*" style={{ display: 'none' }} onChange={handleFileChange} />
    </Box>
  );
};

export default SettingsOrglogo;